const initialState = {
  filters: {}
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'filteredObj':
      return {
        ...state,
        filters: action.payload
      };

    default:
      return state;
  }
};

export default filterReducer;
